import { observable} from 'mobx';

export const globalStore = observable({});